
import { Vue, Component } from 'vue-property-decorator';
import { getFaqList, Faq } from '@/api/faq';

@Component
export default class FaqPage extends Vue {
  private isLoading = false;

  private faqs: Faq[] = [];

  private openUids: string[] = [];

  private activeCategory = '__all__';

  created(): void {
    this.fetchFaqs();
  }

  get categories(): string[] {
    const cats = this.faqs.map((f) => f.category).filter((c): c is string => !!c);
    const unique = Array.from(new Set(cats));
    return unique.length > 0 ? ['__all__', ...unique] : [];
  }

  get filteredFaqs(): Faq[] {
    if (this.activeCategory === '__all__') return this.faqs;
    return this.faqs.filter((f) => f.category === this.activeCategory);
  }

  private async fetchFaqs(): Promise<void> {
    this.isLoading = true;
    try {
      const res = await getFaqList();
      this.faqs = res.data || [];
    } finally {
      this.isLoading = false;
    }
  }

  private toggle(uid: string): void {
    const idx = this.openUids.indexOf(uid);
    if (idx >= 0) {
      this.openUids.splice(idx, 1);
    } else {
      this.openUids.push(uid);
    }
  }
}
